<table mat-table [dataSource]="items$" class="simple-table equal-widths last-col-longer">
  <ng-container matColumnDef="name">
    <th mat-header-cell *matHeaderCellDef>Name</th>
    <td mat-cell *matCellDef="let poc">
      <a *ngIf="isStaffView; else nameTemplate" [routerLink]="staffViewRoute(poc)">{{
        poc.pointOfContactPerson.name.firstLast
      }}</a>
      <ng-template #nameTemplate>
        {{ poc.pointOfContactPerson.name.firstLast }}
      </ng-template>
    </td>
  </ng-container>
  <ng-container matColumnDef="email">
    <th mat-header-cell *matHeaderCellDef>Email</th>
    <td mat-cell *matCellDef="let poc">
      {{ poc.pointOfContactPerson.email }}
    </td>
  </ng-container>
  <ng-container matColumnDef="title">
    <th mat-header-cell *matHeaderCellDef>Title</th>
    <td mat-cell *matCellDef="let poc">{{ poc.title }}</td>
  </ng-container>
  <ng-container matColumnDef="requestInfo">
    <th mat-header-cell *matHeaderCellDef></th>
    <td mat-cell *matCellDef="let poc">
      {{ getRequestLabel(poc) }}
      <br />
      {{ getRequestDate(poc) | date: 'shortDate' }}
    </td>
  </ng-container>
  <ng-container matColumnDef="actions">
    <th mat-header-cell *matHeaderCellDef></th>
    <td mat-cell *matCellDef="let poc">&nbsp;</td>
  </ng-container>
  <ng-container matColumnDef="menu">
    <th mat-header-cell *matHeaderCellDef></th>
    <td mat-cell *matCellDef="let poc">&nbsp;</td>
  </ng-container>
  <tr mat-header-row *matHeaderRowDef="columns"></tr>
  <tr mat-row *matRowDef="let poc; columns: columns" [ngClass]="{ pending: poc.isPending }" [@statusChange]="poc.status"></tr>
</table>
